const env = fetch('/get-env').then(response => response.json());

/**
 * Retrieve environment data.
 *
 * @returns {Promise.<{ debounceDelay, searchUrl, oov2Url }>}
 */
export async function getEnv() {
    return await env;
}
